import coreModuleIcon from '../../assets/icons/core-module.svg';
import programmesIcon from '../../assets/icons/programmes-management.svg';
import communityIcon from '../../assets/icons/community-management.svg';
import supportIcon from '../../assets/icons/support-management.svg';
import eventsIcon from '../../assets/icons/events-management.svg';
import communicationIcon from '../../assets/icons/communication-management.svg';
import reportsIcon from '../../assets/icons/reports-management.svg';
import donorIcon from '../../assets/icons/donor-management.svg';
import bespokeAiIcon from '../../assets/icons/bespoke-ai.svg';

export const MODULE_ICONS = {
  core:           coreModuleIcon,
  programmes:     programmesIcon,
  community:      communityIcon,
  supportmgmt:    supportIcon,
  events:         eventsIcon,
  communications: communicationIcon,
  reports:        reportsIcon,
  donors:         donorIcon,
  bespokeai:      bespokeAiIcon,
};

export const MODULE_LABELS = {
  core:           'Core',
  programmes:     'Programmes',
  community:      'Community',
  supportmgmt:    'Support Mgmt',
  events:         'Events',
  communications: 'Comms',
  reports:        'Reports',
  donors:         'Donors',
  bespokeai:      'AI',
};

// Modules a client can have switched on (excludes the always-on core)
export const TOGGLEABLE_MODULE_KEYS = [
  'programmes', 'community', 'supportmgmt', 'events', 'communications', 'reports', 'donors', 'bespokeai',
];
